












































import { Component, Prop, Watch } from 'vue-property-decorator';
import UiDatePicker from '@/components/ui/ui-date-picker.vue';
import PickerMixin from '@/views/reports/mixins/picker-mixin';

import { mixins } from 'vue-class-component';
import _ from 'lodash';

@Component
export default class UiPeriodPickerInput extends mixins(PickerMixin) {
    @Prop()
    startTimestamp: string;

    @Prop({default: false })
    withTimeMenu: string;

    @Prop()
    endTimestamp: string;

    @Prop()
    dateValue: string;

    @Prop()
    value: TimeRange;

    @Prop()
    startTimestampErrors: string[];

    @Prop()
    endTimestampErrors: string[];

    @Prop()
    timeInTitle: string | boolean;

    @Prop()
    label: string;

    @Prop() 
    labelHelp: string;
    
    //0 -- не прячем поле ошибок
    //1 -- прячем поле ошибок
    //2 -- прячем поле ошибок, но компенсируем высоту
    @Prop({ default: 0 })
    hideDetails: number;
    
    @Prop({ default: true })
    showTimezone: boolean;

    get errorMessages() {
      const startTimestampErrors = this.startTimestampErrors || [];
      const endTimestampErrors = this.endTimestampErrors || [];

      return startTimestampErrors.concat(endTimestampErrors);
    }

  redrawMenu() {
    const picker = this.$refs.picker as any;
    picker.redrawMenu();
  }

  adjustDatePickerPageRange() {
    const picker = this.$refs.picker as any;
    picker.adjustPageRange();
  }

  get items(): Bemob.ListItem[] {
    return this.baseItems.map((item: any) => ({
      key: item.value,
      title: item.text,
      click: () => {
        this.$emit('update:dateValue', item.value);
        this.setDateRange(item.value);
        this.$nextTick(() => {
          this.adjustDatePickerPageRange();
        });
      }
    }));
  }

  @Watch('value')
  onValueChanged() {
    if(!this.isMenuOpen) {
      this.firstOpen = true;    
    }
  }

  firstOpen: boolean = true;
  isMenuOpen: boolean = false;

  adjustPageRange(value: boolean) {
    this.isMenuOpen = value;
    
    if(this.firstOpen && value) {
      const picker = this.$refs.picker as UiDatePicker;
      picker.adjustPageRange();

      // пока оставим перерасчет положение только для первого открытия
      // если потребуется возвращатся на позицию после открытия, закометировать этот параметр
      this.firstOpen = false;
    }
  }

  closeMenu() {
    const picker = this.$refs.picker as any;
    picker.toggleMenu(false);
  }

  get formatedDate() {
    if(this.dateValue === 'customDateTime' || !this.withTimeMenu ){
      return null;
    } else {
      const item = this.baseItems.find((item) => item.value === this.dateValue) || this.baseItems[0];
      return item.text;
    }
  }
 
  onRangeChanged(value) {
    this.$emit('input', value);
    const keys = Object.keys(this.getRangeValueColection({timezone:value.timezone}));
    let customDate = true;
    const valueTime = {from:value.from,to:value.to};

    for(let i of keys) {
      if(_.isEqual(this.getRangeValueColection({timezone:value.timezone})[i], valueTime)) {
        if(this.dateValue !== i) {
          this.$emit('update:dateValue', i);
        }
        customDate = false;
        break;
      }
    }

    if(customDate) {
      this.$emit('update:dateValue', 'customDateTime');
    }
  }
  
  setDateRange(val: any) {
    const rangeCollection = this.getRangeValueColection({timezone:this.value.timezone})

    if(rangeCollection[val]) {
      this.$emit('input', {
        ...this.value,
        ...rangeCollection[val]
      })
    }
  }
 
}
